// extracted by mini-css-extract-plugin
export default {"content":"Products_content__G96zw"};